<template>
    <v-layout row wrap class="user-menu__stats-item align-center"
              :class="textColor"
    >
        <v-flex md12 xs6 class="user-menu__stats-number">{{ number }}</v-flex>
        <v-flex md12 xs6 class="user-menu__stats-text">{{ name }}</v-flex>
    </v-layout>
</template>

<script>
export default {
  props: {
    number: {
      type: Number,
    },
    name: {
      type: String,
    },
    color: {
      type: String,
    },
  },
  computed: {
    textColor() {
      return {
        'red-text'      : this.color=='red',
        'green-text'    : this.color=='green',
        'dark-grey-text': this.color=='grey',
      };
    },
  },
};
</script>

